import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Row } from 'scripts/styled-components'
import apiFetch from '@wordpress/api-fetch'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import InsightTeaser from '../InsightTeaser'
import IssueTeaser from '../IssueTeaser'
import NewsEventsTeaser from '../NewsEventsTeaser'
import { Wrapper } from './custom.styled'

const Teaserboxes = ({
  postType,
  displayTeasers,
  category,
  teasers,
  isSlider = true,
  isEditor = false,
}) => {
  const [posts, setPosts] = useState([])

  useEffect(() => {
    if (displayTeasers === 'all') {
      apiFetch({
        path: `/dhsv/v1/query?postType=${postType}&count=52`,
      }).then(response => setPosts(response.posts))
    } else if (displayTeasers === 'category') {
      apiFetch({
        path: `/dhsv/v1/query?postType=${postType}&${postType}_category=${category}&count=52`,
      }).then(response => setPosts(response.posts))
    } else if (displayTeasers === 'manually') {
      if (teasers) {
        let postIds = String(teasers)
        apiFetch({
          path: `/dhsv/v1/query?postType=${postType}&postIn=${postIds}`,
        }).then(response => {
          response.posts.sort(function (a, b) {
            return teasers.indexOf(a.id) - teasers.indexOf(b.id)
          })
          setPosts(response.posts)
        })
      }
    }
  }, [postType, displayTeasers, category, teasers])

  function renderSwitch(data) {
    switch (postType) {
      case 'insight':
        return <InsightTeaser {...data} />
      case 'issue':
        return <IssueTeaser {...data} />
      case 'news-events':
        return <NewsEventsTeaser {...data} />
    }
  }

  const Posts = () => {
    return (
      posts.length > 0 &&
      posts.map(item =>
        isSlider ? (
          <SplideSlide>
            {renderSwitch({ post: item, isSlider, isEditor })}
          </SplideSlide>
        ) : (
          renderSwitch({ post: item, isSlider, isEditor })
        )
      )
    )
  }

  const splide_options = {
    pagination: false,
    perPage: 4,
    gap: 20,
    breakpoints: {
      1200: {
        perPage: 3,
      },
      992: {
        perPage: 2,
      },
      576: {
        perPage: 1,
      },
    },
  }

  return (
    <Wrapper>
      {isSlider ? (
        <Splide options={splide_options}>
          <Posts />
        </Splide>
      ) : (
        <Row mobileDirection={'wrap'} direction={'wrap'} gap={'20px'}>
          <Posts />
        </Row>
      )}
    </Wrapper>
  )
}

export default Teaserboxes

Teaserboxes.propTypes = {
  postType: PropTypes.oneOf(['insight', 'issue', 'news-events']),
  displayTeasers: PropTypes.string,
  category: PropTypes.string,
  teasers: PropTypes.array,
  isSlider: PropTypes.bool,
  isEditor: PropTypes.bool,
}
